module.exports = __webpack_public_path__ + "img/smallLogo.60382649.svg";